import { Divider } from "../Divider.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/divider/variants/HorizontalDivider.tsx
const HorizontalDivider = ({ variant = "full", ...restProps }) => {
	return /* @__PURE__ */ jsx(Divider, {
		...restProps,
		variant,
		orientation: "horizontal"
	});
};

//#endregion
export { HorizontalDivider };